import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator, endpointQuery } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const actions = createActions({
  TASK: {
    GET_COMPLETED: (query) => ({ query }),
    API: {
      GET_COMPLETED: apiResourceActionCreator('completedTasks')
    }
  }
})

export const apiAction = (authToken, query) => commonApiActions.authenticated.get(`${API_ENDPOINT}/completed${endpointQuery(query)}`, authToken, actions.task.api.getCompleted);

function* getCompleted(action) {
  const authToken = yield select(authTokenSelector);

  yield put(apiAction(authToken, action.payload.query));
}

const configuration = {
  name: 'getCompleted',
  action: actions,
  sagas: getCompleted,
  reducers: {
    request: (state, action) => ({
      ...state,
      isFetchingCompleted: true
    }),
    success: (state, action) => ({
      ...state,
      completedTasks: action.payload.completedTasks,
      isFetchingCompleted: false
    }),
    failed: (state, action) => ({
      ...state,
      isFetchingCompleted: false
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/task/configurations/getCompleted.js